document.addEventListener('DOMContentLoaded', () => {

  const openBtn = document.querySelector('[data-open-sizechart]');
  const closeBtn = document.querySelector('[data-close-sizechart]');
  const drawer = document.querySelector('.sizeguide_content');

  openBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    drawer?.classList.add('active');
    document.body.classList.add('sizeguide-open');
  });

  closeBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    drawer?.classList.remove('active');
    document.body.classList.remove('sizeguide-open');
  });

  document.querySelector('.sizeguide-overlay').addEventListener('click', () => {
    closeBtn.click();
  })
});